/**
 * VerticalCardInfo component.
 */
import Addon from '@shared/classes/addon';
import Button from '../buttons/cardButton';
import Container from '../../atoms/container/verticalCardInfoContainer';
import EpgEvent from '@shared/classes/epgEvent';
import FastEvent from '@shared/classes/fastEvent';
import FlavourConfig from '@shared/config/flavours';
import OpacityAnimation from '@components/utils/helpers/opacityAnimation';
import Plan from '@shared/classes/plan';
import RegularEvent from '@shared/classes/regularEvent';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { CardButtonIcon } from '@shared/types/enums/card';
import { useMemo } from 'react';

interface Props {
  item: Addon | EpgEvent | FastEvent | RegularEvent;
  focused: boolean;
  plan: Plan | null;
}

export default function VerticalCardInfo({
  item,
  focused = false,
  plan,
}: Props) {
  const { color, display, icon } = useMemo(() => {
    const color = plan?.colorHex;
    const display = !!(plan || focused);
    const isFutureEvent = (item?.date?.start || 0) > new Date().getTime();
    let icon;
    let text;
    if (plan) {
      icon = CardButtonIcon.PLAN;
      text = focused
        ? TranslationManager.get('MISC.CARDS.SUBSCRIBE')
        : plan?.name.replace(FlavourConfig.appTitle, '');
    } else if (isFutureEvent) {
      icon = CardButtonIcon.INFO;
      text = TranslationManager.get('MISC.CARDS.MORE_INFO');
    } else {
      icon = CardButtonIcon.PLAY;
      text = TranslationManager.get('MISC.CARDS.VIEW_NOW');
    }
    return { color, display, icon, text };
  }, [item, focused, plan]);

  return (
    <OpacityAnimation>
      <Container>
        {display ? (
          <Button color={color} focused={focused} iconType={icon} />
        ) : null}
      </Container>
    </OpacityAnimation>
  );
}
